export default __webpack_public_path__ + "static/media/Front-Villa-Jawad.b31c44d5.jpg";